// components/SwEventDrawer/hooks/useEventFormHandlers.js
import { useCallback } from 'react';

export const useEventFormHandlers = (formik) => {
  const handleChange = useCallback((key, value) => {
    formik.setFieldValue(key, value);
    formik.setFieldTouched(key, true);
  }, [formik]);

  const handleBlur = useCallback((fieldName) => {
    formik.setFieldTouched(fieldName, true);
  }, [formik]);

  const handleTicketTypeChange = useCallback((index, field, value) => {
    const updatedTicketTypes = [...formik.values.ticketTypes];
    const oldAccessType = updatedTicketTypes[index].accessType;
    
    updatedTicketTypes[index][field] = value;
    formik.setFieldValue('ticketTypes', updatedTicketTypes);
    formik.setFieldTouched(`ticketTypes[${index}].${field}`, true);
    
    if (field === 'accessType') {
      const newAccessSlots = { ...formik.values.accessSlots };
      
      if (oldAccessType && oldAccessType.trim()) {
        delete newAccessSlots[oldAccessType];
      }
      
      if (value && value.trim()) {
        newAccessSlots[value] = '';
      }
      
      syncAccessSlots(updatedTicketTypes, formik);
    }
  }, [formik]);

  const handleAccessSlotChange = useCallback((accessType, value) => {
    formik.setFieldValue(`accessSlots.${accessType}`, value);
    formik.setFieldTouched(`accessSlots.${accessType}`, true);
  }, [formik]);

  const handlePaymentOptionChange = useCallback((option) => {
    formik.setFieldValue('paymentOption', option);
    formik.setFieldTouched('paymentOption', true);
  }, [formik]);

  const addNewTicketType = useCallback(() => {
    const newTicketType = { accessType: '', price: '', description: '' };
    const updatedTicketTypes = [...formik.values.ticketTypes, newTicketType];
    formik.setFieldValue('ticketTypes', updatedTicketTypes);
  }, [formik]);

  const removeTicketType = useCallback((index) => {
    const ticketToRemove = formik.values.ticketTypes[index];
    const updatedTicketTypes = formik.values.ticketTypes.filter((_, i) => i !== index);
    
    formik.setFieldValue('ticketTypes', updatedTicketTypes);
    
    if (ticketToRemove.accessType && ticketToRemove.accessType.trim()) {
      const newAccessSlots = { ...formik.values.accessSlots };
      delete newAccessSlots[ticketToRemove.accessType];
      formik.setFieldValue('accessSlots', newAccessSlots);
    }
    
    syncAccessSlots(updatedTicketTypes, formik);
  }, [formik]);

  return {
    handleChange,
    handleBlur,
    handleTicketTypeChange,
    handleAccessSlotChange,
    handlePaymentOptionChange,
    addNewTicketType,
    removeTicketType
  };
};

// Helper function for syncing access slots
const syncAccessSlots = (ticketTypes, formik) => {
  const newAccessSlots = {};
  
  ticketTypes.forEach(ticket => {
    if (ticket.accessType && ticket.accessType.trim()) {
      newAccessSlots[ticket.accessType] = formik.values.accessSlots[ticket.accessType] || '';
    }
  });
  
  formik.setFieldValue('accessSlots', newAccessSlots);
};